import React from 'react'
import { InvoiceAmortisationMain } from './InvoiceAmortisationMain'
import { InvoiceAmortisationForm } from './InvoiceAmortisationForm/InvoiceAmortisationForm'
import { InvoiceAmortisationDetail } from './InvoiceAmortisationDetail/InvoiceAmortisationDetail'

const invoiceAmortisationRoutes = [
  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path: '/account-receivable/:CompanyID/invoice-amortisation',
    },
    component: <InvoiceAmortisationMain />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/invoice-amortisation/:AmortisationID/detail',
    },
    component: <InvoiceAmortisationDetail />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/account-receivable/:CompanyID/invoice-amortisation/add',
    },
    component: <InvoiceAmortisationForm formMode="add" />,
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/invoice-amortisation/:AmortisationID/edit',
    },
    component: <InvoiceAmortisationForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/invoice-amortisation/:AmortisationID/approve-reject',
    },
    component: <InvoiceAmortisationForm mode="approve-reject" />,
  },
  {
    props: {
      exact: true,
      path:
        '/account-receivable/:CompanyID/invoice-amortisation/:AmortisationID/resubmit',
    },
    component: <InvoiceAmortisationForm formMode="resubmit" />,
  },
]

export default invoiceAmortisationRoutes
